import {handleAjaxError, doNextStep} from 'src/wp-migrate-db-pro/asset/src/js/helpers/utils';
import ThemesPluginsTransfer from './ThemePluginFilesTransfer';

const $ = window.jQuery;
const wpmdb = window.wpmdb;
const ajaxurl = window.ajaxurl;

export default class ThemePluginFilesMigration {

	constructor() {
		this.transfer = new ThemesPluginsTransfer();

		$( document ).ready( () => {
			this.hooks();
			this.is_themes_migration = $( '#migrate_themes' ).is( ':checked' );
			this.is_plugins_migration = $( '#migrate_plugins' ).is( ':checked' );
			this.is_media_files_migraton = $( '#media-files' ).is( ':checked' );
		} );
	}

	hooks() {
		$.wpmdb.add_action( 'wpmdb_add_migration_stages', this.addThemesPluginsStage );
		$.wpmdb.add_filter( 'wpmdb_before_migration_complete_hooks', this.themesPluginsHook );
	}

	themesPluginsHook = ( hooks, args, instance ) => {
		if ( (false === this.is_themes_migration && false === this.is_plugins_migration) || -1 === [
			'push',
			'pull'
		].indexOf( wpmdb.functions.wpmdb_migration_type() ) ) {
			return hooks;
		}

		hooks.push( this.startFileMigration );
		return hooks;
	};

	/**
	 * Adds the import migration stage
	 *
	 * object args
	 */
	addThemesPluginsStage = ( args, instance ) => {
		const migration_type = 'push' === wpmdb.functions.wpmdb_migration_type() ? 'local' : 'remote';

		if ( -1 !== [
			'push',
			'pull'
		].indexOf( wpmdb.functions.wpmdb_migration_type() ) ) {

			this.is_themes_migration = $( '#migrate_themes' ).is( ':checked' );
			this.is_plugins_migration = $( '#migrate_plugins' ).is( ':checked' );

			if ( this.is_themes_migration ) {
				wpmdb.current_migration.model.addStage( 'themes', [], migration_type, {
					strings: {
						stage_title: window.wpmdbtp_settings.strings.themes,
						itemsName: window.wpmdbtp_settings.strings.themes
					}
				} );
			}

			if ( this.is_plugins_migration ) {
				wpmdb.current_migration.model.addStage( 'plugins', [], migration_type, {
					strings: {
						stage_title: window.wpmdbtp_settings.strings.plugins,
						itemsName: window.wpmdbtp_settings.strings.plugins
					}
				} );
			}
		}
	};

	startFileMigration = () => {
		const wpmdb = window.wpmdb;
		this.next_stage = $( '#migrate_themes' ).is( ':checked' ) ? 'themes' : 'plugins';
		const self = this;

		// Change 'next' stage if there's a media files migration going on 🖼️
		if ( $( '#media-files' ).is( ':checked' ) ) {
			$.wpmdb.add_action( 'wpmdbmf_media_transfer_complete', function() {
				wpmdb.current_migration.model.setActiveStage( self.next_stage );
				wpmdb.common.next_step_in_migration = {
					fn: self.transfer.initializeTransfer,
					args: [ self.next_stage ]
				};
				wpmdb.functions.execute_next_step( new ThemesPluginsTransfer() );
			} );
		} else {
			wpmdb.current_migration.model.setActiveStage( this.next_stage );
			wpmdb.common.next_step_in_migration = {
				fn: this.transfer.initializeTransfer,
				args: [ this.next_stage ]
			};
			wpmdb.functions.execute_next_step( this.transfer );
		}

		return this.next_stage;
	}
}



// WEBPACK FOOTER //
// ./src/wp-migrate-db-pro-theme-plugin-files/asset/src/js/class/ThemePluginFilesMigration.js